module.exports = __webpack_public_path__ + "img/theCover_10.1b371cf5.jpg";